import {
  type Account,
  type SourceAccount,
  type RestoreAccount,
} from '@repo/api-gw-sdk';
import semver from 'semver';

import { isRestoreAccount, isSourceAccount } from './accounts';

export const extractRoleArn = (roleArn: string) => {
  const roleParts = roleArn.split(/:|\//).reverse();
  const role = roleParts[0];
  const accountId = roleParts[2];
  return { role, accountId };
};

export const getAccountInstalledVersion = (
  account: Account | SourceAccount | RestoreAccount
) =>
  isSourceAccount(account) || isRestoreAccount(account)
    ? account.version?.installed
    : account.installedVersion;

export const getAccountLatestVersion = (
  account: Account | SourceAccount | RestoreAccount
) =>
  isSourceAccount(account) || isRestoreAccount(account)
    ? account.version?.latest
    : account.latestVersion;

export const isAccountRoleOld = (
  account: Account | SourceAccount | RestoreAccount
) => {
  const installedVersion = getAccountInstalledVersion(account);
  const latestVersion = getAccountLatestVersion(account);
  return (
    !!latestVersion && semver.lt(installedVersion ?? '1.0.0', latestVersion)
  );
};

export const isAccountRoleMajorMinorVersionOld = (
  account: Account | SourceAccount | RestoreAccount
) => {
  const installedVersion = getAccountInstalledVersion(account);
  const latestVersion = getAccountLatestVersion(account);
  return (
    !!latestVersion &&
    isMajorMinorLess(installedVersion ?? '1.0.0', latestVersion)
  );
};

function isMajorMinorLess(a: string, b: string) {
  const normalized = (v: string) => `${semver.major(v)}.${semver.minor(v)}.0`;
  return semver.lt(normalized(a), normalized(b));
}
